/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find GridCraft download resources, follow installation guides, compare features with Microsoft Excel, and explore hands-on usage experiences.`)
};

const zh_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供 GridCraft 下载资源、安装指南、与 Microsoft Excel 的功能对比及使用体验，帮助你了解软件并开始使用。`)
};

/**
* | output |
* | --- |
* | "Find GridCraft download resources, follow installation guides, compare features with Microsoft Excel, and explore hands-on usage experiences." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_metadata_description(inputs)
	return zh_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }